var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#6F8BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0V16Z",
    fill: "#7D97FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4387 4.77674C12.2601 4.5982 11.9707 4.5982 11.7922 4.77674L6.3153 10.2537L4.21009 8.14844C4.03157 7.9699 3.74214 7.96992 3.56359 8.14844C3.38505 8.32695 3.38505 8.61638 3.56359 8.79492L5.99205 11.2233C6.17052 11.4019 6.46016 11.4017 6.63855 11.2233L12.4387 5.42324C12.6172 5.24472 12.6172 4.95528 12.4387 4.77674Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00098 8.56796L6.3153 10.2537L4.21009 8.14844C4.03157 7.9699 3.74214 7.96992 3.56359 8.14844C3.38505 8.32695 3.38505 8.61638 3.56359 8.79492L5.99205 11.2233C6.17052 11.4019 6.46016 11.4017 6.63855 11.2233L8.00098 9.86092V8.56796Z",
    fill: "#7D97FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfChecked);
export default __webpack_public_path__ + "static/media/half_checked.5103aed87c60e460b612b98c9f9613cd.svg";
export { ForwardRef as ReactComponent };